
import IndexModel from "@/service/v10/sigap/IndexModel";
 
class UnidadeService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Unidade' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public getTodos(search) : Promise<any> {  
        if(search){
            return  new Promise((resolve, reject) => {
                this.getAxios().get( this.url + '?search=' + search    )
                .then(response => {    
                    resolve( response.data);  
                })
                .catch(error => {  
                    reject(error.response);
                }) 
            }); 
        } 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public getTipos( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipos'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public ativar( id ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/Ativar'  , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    
    public inativar( id ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/' + id  + '/Inativar'  , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    
    public sincronizarViaRh(  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().post( this.url + '/Rh/Sincronizar' , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 

}
 

export default UnidadeService;

